export default function () {
    function Child() {
        this.name = "child";
        this.say = function () {
            return "Hi, " + this.name;
        };
    }

    this.child = new Child();
};


//////////////////
// WEBPACK FOOTER
// ./resources/js/example05.js
// module id = 9
// module chunks = 0